<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3">
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3">
          <c-select
            :comboItems="col1Items"
            type="search"
            itemText="codeName"
            itemValue="code"
            name="col1"
            label="자체감사종류"
            v-model="searchParam.col1"
          ></c-select>
        </div>
        <div class="col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3">
          <c-text
            name="search"
            placeholder="자체감사명"
            label="자체감사명"
            v-model="searchParam.col2"
          ></c-text>
        </div>
      </template>
    </c-search-box>
    <c-table
      ref="table"
      title="자체감사 목록"
      tableId="accidentSeq"
      :columns="grid.columns"
      :data="grid.data"
      @linkClick="linkClick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <div>
          <q-btn-group>
            <c-btn label="등록" :editable="editable" icon="add" @btnClicked="onItemClick" />
            <c-btn label="검색" icon="search" @btnClicked="getList" />
          </q-btn-group>
        </div>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
export default {
  name: "process-accident",
  data() {
    return {
      grid: {
        columns: [
          {
            name: "plantName",
            field: "plantName",
            label: "사업장",
            align: "center",
            sortable: true,
          },
          {
            name: "col0",
            field: "col0",
            label: "감사년도",
            align: "center",
            style: 'width: 80px',
            sortable: true,
          },
          {
            name: "col1",
            field: "col1",
            label: "감사명",
            align: "left",
            sortable: true,
            type: "link",
          },
          {
            name: "col2",
            field: "col2",
            label: "감사종류",
            align: "center",
            sortable: true,
          },
          {
            name: "col4",
            field: "col4",
            label: "감사시작일",
            align: "center",
            style: 'width: 120px',
            sortable: true,
          },
          {
            name: "col5",
            field: "col5",
            label: "감사종료일",
            align: "center",
            style: 'width: 120px',
            sortable: true,
          },
          {
            name: "col3",
            field: "col3",
            label: "진행단계",
            align: "center",
            sortable: true,
          },
        ],
        data: [],
      },
      searchParam: {
        plantCd: null,
        col1: null,
        col2: '',
      },
      col1Items: [
        { code: "1", codeName: "정기자체감사" },
        { code: "2", codeName: "특별자체감사" },
        { code: "3", codeName: "외부감사" },
      ],
      editable: true,
      searchUrl: "",
      popupOptions: {
        target: null,
        title: "",
        visible: false,
        isFull: true,
        top: "",
        param: {},
        closeCallback: null,
      },
      isResult: false,
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  methods: {
    init() {
      // role setting
      // url setting
      // code setting
      // list setting
      this.getList();
    },
    getList() {
      this.grid.data = [
        {
          plantName: '사업장1',
          col0: '2020',
          col1: '1사업장 특별자체감사',
          col2: '특별자체감사',
          col3: '작성중',
          col4: '2020-01-28',
          col5: '2020-02-27',
        },
        {
          plantName: '사업장2',
          col0: '2021',
          col1: '2사업장 특별자체감사',
          col2: '특별자체감사',
          col3: '계획완료',
          col4: '2021-04-24',
          col5: '2021-05-23',
        },
        {
          plantName: '사업장2',
          col0: '2020',
          col1: '2사업장 정기자체감사',
          col2: '정기자체감사',
          col3: '감사완료',
          col4: '2020-03-12',
          col5: '2020-04-11',
        },
      ];
    },
    /* eslint-disable no-unused-vars */
    linkClick(row, col, index) {
      this.popupOptions.title = "자체감사 상세"; // 안전사고 상세
      this.popupOptions.param = {
        row: row,
      };
      this.popupOptions.target = () =>
      import(`${"./complianceDetail.vue"}`);
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup(type) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
    onItemClick() {
      this.popupOptions.target = () =>
      import(`${"./complianceDetail.vue"}`);
      this.popupOptions.title = '자체감사 계획'; // 안전사고 상세
      this.popupOptions.param = null;
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
  },
};
</script>
